export default function CTASection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="bg-gradient-to-r from-teal-500 to-teal-600 rounded-2xl p-12 md:p-16 text-center shadow-xl">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Ready to Find Your Next Home?
          </h2>
          <p className="text-xl text-white/95 mb-8 max-w-2xl mx-auto leading-relaxed">
            Don't miss out on quality rental properties in El Paso. Join our waitlist today and be the first to know about available homes that match your needs.
          </p>
        </div>
      </div>
    </section>
  );
}